import React from 'react';
import './Ticket.css'
import NavDock from '../Components/Layout/NavDock';

import Curve from '../Assets/Icons/CurveGreen.svg'
import User from '../Assets/Icons/User.svg'
import Loc from '../Assets/Icons/Loc.svg'
import Qr from '../Assets/decals/QR.svg'
import Barcode from '../Assets/decals/Barcode.svg'
import Stitch from '../Assets/decals/TicketStitch2.svg'
import CutoutRight from '../Assets/decals/CutoutRight.svg'
import CutoutLeft from '../Assets/decals/CutoutLeft.svg'

const Ticket = () => {
    return ( 
        <main className='Ticket'>
            <div className='TopBar'></div>

            <div className='MainTicket'>
                <p className='TicketPrompt'>
                    Hold Next to Reader
                </p>

                <div className='DigitalTicket'>
                    <div className='TicketHeader'>
                        <p className='EventTitle'>
                            EVs Electrify! Egypt
                        </p>
                        <div className='TicketType'>
                            <p>VIP <br /> PASS</p>
                        </div>
                    </div>

                    <div className='TicketBody'>  

                        <img className='COLeft' src={CutoutLeft} alt="" />
                        <img className='CORight' src={CutoutRight} alt="" />

                        <div className='TicketInfo'>
                            <div className='UserInfo'>
                                <p className='InfoTitle'>
                                    <img className='InfoTitle' src={User} alt="" />
                                Attendee
                                </p>
                                <p className='InfoValue'>
                                    Ahmed Hassan
                                </p>
                            </div>

                            <div className='UserInfo'>
                                <p className='InfoTitle'>
                                Ticket No.
                                </p>
                                <p className='InfoValue'>
                                    #EV-84729
                                </p>
                            </div>
                        </div>  

                        <div className='UserInfo'>
                            <p className='InfoTitle'>
                                <img className='InfoTitle' src={Loc} alt="" />
                                Location
                            </p>
                            <p className='InfoValue'>
                                Cairo International Convention Centre, HALL 4
                            </p>
                        </div>

                        <p className='TicketDesc'>
                            Please present this digital ticket or the QR code at the entrance for scanning. A copy has been sent to ahmed.hassan@example.com.
                        </p>

                        <div className='TicketScan'>
                            <p className='ScanPrompt'>Scan Here</p>
                            <img className='QrCode' src={Qr} alt="" />

                            <img className='Stitch2' src={Stitch} alt="" />
                            <img className='Barcode' src={Barcode} alt="" />

                        </div>
                        
                    </div>
                </div>
            </div>

            <NavDock Curve={Curve} NotchClass='NotchCurve' />
        </main>
     );
}
 
export default Ticket;